import { render, staticRenderFns } from "./followup.vue?vue&type=template&id=9013ac9a&scoped=true"
import script from "./followup.vue?vue&type=script&lang=js"
export * from "./followup.vue?vue&type=script&lang=js"
import style0 from "./followup.vue?vue&type=style&index=0&id=9013ac9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9013ac9a",
  null
  
)

export default component.exports